import { Directive, ElementRef } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Directive({
  selector: '[custom-conterback-pc]' 
})
export class CustomConterbackPcDirective {

  constructor(private el: ElementRef, private colorProvider: ColorProvider, events: Events) {
    
    this.update();
    events.subscribe('color:updated', () => {
      this.update()
    });

  }

  update() {
    this.colorProvider.getBGCounterback().then( bg => this.el.nativeElement.style.backgroundImage = bg);
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-conterback-pc/custom-conterback-pc.ts